module.exports = __webpack_public_path__ + "img/antes_despues_02.a1353a62.png";